import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'src/makeStyles';
import CheckIcon from '@mui/icons-material/Check';
import DialogWithTitle from '../DialogWithTitle';
import { useTranslation, withTranslation } from '../../src/i18n';
import { colors, fontSize, inputSubmitStyles } from '../../constants/styleConstants';
import { TP } from '../../constants/consts';
import Logo from '../Logo';
import { selectLoginErrorMessage, selectLoginLoadingState } from '../../containers/App/selectors';
import { getUserInfo } from '../../utils/auth';

const useStyles = makeStyles()({
  archiveDialog: {
    '& .MuiDialog-paperScrollPaper': {
      maxWidth: '348px',
      minWidth: '348px',
    },
    '& .MuiDialog-paperFullScreen': {
      maxWidth: '100% !important',
    },
  },
  contentClass: {
    padding: '20px',
    background: '#fafafa',
  },

  title: {
    fontSize: fontSize.h6,
    color: '#464646',
    fontWeight: 'bold',
    marginTop: '2px',
    margin: 0,
  },
  subTitle: {
    fontSize: fontSize.medium,
    color: colors.grey3,
    marginTop: '2px',
    margin: 0,
  },
  subTitle2: {
    fontSize: fontSize.basic,
    color: colors.grey3,
    fontWeight: 'bold',
    marginTop: '2px',
    lineHeight: '20px',
    margin: 0,
  },

  logo: {
    width: 125,
    height: 12,
  },
  errorMessage: {
    display: 'flex',
    fontSize: fontSize.smallTitle,
    color: colors.red,
    justifyContent: 'center',
    marginTop: 10,
  },
  message: {
    color: '#464646',
    fontSize: fontSize.description,
    fontWeight: 300,
    margin: 0,
    marginBottom: 16,
    textAlign: 'center',
  },
  loginButton: {
    ...inputSubmitStyles,
    width: '100%',
  },
  listItems: {
    marginTop: '15px',
    backgroundColor: colors.background.grayCard,
    padding: '13px 17px 16px 16px',
    '& ul': {
      listStyle: 'none',
      padding: 0,
    },
    '& li': {
      display: 'flex',
      margin: '0px 0px 20px 0px',
      alignItems: 'center',
    },
    '& span': {
      marginLeft: '11px',
    },
  },
  link: {
    color: colors.blueChip,
    '&:hover': {
      color: colors.blueChip,
    },
    marginLeft: '4px',
    cursor: 'pointer',
    textTransform: 'lowercase',
  },
  icon: {
    color: colors.primary,
  },
});

const ArchiveDialog = ({ isOpen, onClose, redirect }) => {
  const { t } = useTranslation();
  const { classes, cx } = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const customIcon = <CheckIcon className={classes.icon} />;
  return (
    <DialogWithTitle
      className={classes.archiveDialog}
      contentClass={classes.contentClass}
      open={isOpen}
      onClose={onClose}
      fullScreen={fullScreen}
      closeButton
    >
      <>
        <p className={classes.title}>{t(`${TP}.FN_NO_ARCHIVE_ACCESS`)}</p>
        <p className={classes.subTitle}>
          {t(`${TP}.FN_ARCHIVE_ACCESS_DESC`)}
          <span className={classes.link} onClick={redirect}>
            {t(`${TP}.m_ARTICLES_CLICK_HERE`)}
          </span>
        </p>
        <div className={classes.listItems}>
          <p className={classes.subTitle2}>{t(`${TP}.FN_ARCHIVE_ACCESS_HEADING`)}</p>
          <ul>
            <li>
              {customIcon}
              <span>{t(`${TP}.FN_ARCHIVE_ACCESS_BENIFIT_1`)}</span>
            </li>
            <li>
              {customIcon}
              <span>{t(`${TP}.FN_ARCHIVE_ACCESS_BENIFIT_2`)}</span>
            </li>
            <li>
              {customIcon}
              <span>{t(`${TP}.FN_ARCHIVE_ACCESS_BENIFIT_3`)}</span>
            </li>
          </ul>
        </div>

        <button className={classes.loginButton} onClick={redirect}>
          {t(`${TP}.FN_GET_ARCHIVE_ACCESS`)}
        </button>

        {fullScreen && (
          <div className={classes.logoContainer}>
            <Logo className={classes.logo} />
          </div>
        )}
      </>
    </DialogWithTitle>
  );
};

const mapStateToProps = createStructuredSelector({
  isLoginLoading: selectLoginLoadingState(),
  error: selectLoginErrorMessage(),
});
const withConnect = connect(mapStateToProps, null);

ArchiveDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  redirect: PropTypes.func,
};

export default compose(withConnect, withTranslation())(ArchiveDialog);
